import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { jsPDF } from 'jspdf';


@Component({
  selector: 'app-bank-details-generator',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './bank-details-generator.component.html',
  styleUrl: './bank-details-generator.component.scss'
})
export class BankDetailsGeneratorComponent {
  @Input() deposit_details: any;
  @Input() amount: string = '';

  constructor(private translate: TranslateService) { }

  async generatePDF() {
    const doc = new jsPDF();

    const logoBase64 = 'data:image/png;base64,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';
    doc.addImage(logoBase64, "PNG", 10, 0, 40, 40);

    // Set font
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    const title = await this.translate.get('generator.bank.details').toPromise();
    doc.text(title, 105, 40, { align: "center" });

    // Reset font
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);

    // Add transfer information
    const info = [
      { label: await this.translate.get('topup.bank.details.beneficiary').toPromise(), value: "FUTAMOBILE SARL" },
      { label: await this.translate.get('topup.bank.details.reference').toPromise(), value: this.deposit_details.reference },
      { label: await this.translate.get('simple_payment.account_number').toPromise(), value: this.deposit_details.account_number },
      { label: await this.translate.get('topup.bank.details.bank.code').toPromise(), value: this.deposit_details.branch_code },
      { label: await this.translate.get('topup.bank.details.amount').toPromise(), value: this.amount },
      { label: await this.translate.get('topup.bank.details.bank').toPromise(), value: this.deposit_details.bank_operator_id.toUpperCase() },
      { label: "IBAN", value: this.deposit_details.iban },
    ];

    let yPosition = 60;
    info.forEach(item => {
      doc.text(`${item.label}:`, 20, yPosition);
      doc.text(item.value, 80, yPosition);
      yPosition += 10;
    });

    // Add note
    doc.setFont("helvetica", "italic");
    doc.setFontSize(10);
    const noteTemplate = await this.translate.get('generator.bank.details.note').toPromise();
    // const note = `To ensure that Futa can link this transfer to your account, please enter ${this.deposit_details.reference} where you specify the reason for the transfer.`;
    const note = noteTemplate.replace('{reference}', this.deposit_details.reference);
    const splitNote = doc.splitTextToSize(note, 170);
    doc.text(splitNote, 20, yPosition + 10);

    // Save the PDF
    doc.save("bank_transfer_info.pdf");
  }
}
